module.exports = __webpack_public_path__ + "img/tradePassword.55f08c5c.png";